import React from 'react';
import Link from 'next/link';
import { Logo } from '../../utils';

import { LogoContainer } from './styles';

const Logotype = () => (
  <LogoContainer>
    <Link href="/">
      <a>
        <Logo width="100%" height="100%" />
      </a>
    </Link>
  </LogoContainer>
);

export default Logotype;
